import FontFaceObserver from 'fontfaceobserver'

export default () => {
	const $html = document.getElementsByTagName('html')[0]
	const light = new FontFaceObserver('Metric-Light')
	const regular = new FontFaceObserver('Metric-Regular')
	const medium = new FontFaceObserver('Metric-Medium')

	Promise.all([light.load(), regular.load(), medium.load()])
		.then(() => $html.classList.add('fonts-loaded'))
		.catch(() => $html.classList.add('fonts-failed'))
}


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
